// import React, { useEffect, useState } from "react";
// import { Row, Col, Input, Label, Button, Table } from "reactstrap";
// import { Formik, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import Flatpickr from "react-flatpickr";
// import { createSelector } from "reselect";
// import { useDispatch, useSelector } from "react-redux";
// import Select from "react-select";
// import Skeleton from "react-loading-skeleton";

// import { fetchTaxList } from "../../../slices/TaxMaster/thunk";
// import { fetchCreditNoteById } from "../../../slices/CreditNote/thunk";

// const validationSchema = Yup.object({
//   taxId: Yup.string().required("Tax is required"),
//   creditNoteDate: Yup.date().required("Credit note date is required"),
//   amountInclGst: Yup.number()
//     .typeError("Amount must be a number")
//     .required("Amount is required")
//     .moreThan(0, "Amount must be greater than 0"),
// });

// const EditCreditNoteForm = ({ creditNoteId, onSubmit, onCloseForm }) => {
//   const dispatch = useDispatch();

//   const [totals, setTotals] = useState({
//     taxableAmount: 0,
//     cgst: 0,
//     sgst: 0,
//     igst: 0,
//     totalGst: 0,
//     grandTotal: 0,
//   });

//   const selector = createSelector(
//     (state) => state,
//     (state) => ({
//       taxes: state.TaxMaster.taxes,
//       customersList: state.Customer.customers,
//       selectedCreditNote: state.CreditNote.selectedCreditNote,
//       loading: state.CreditNote.loading,
//     }),
//   );

//   const { taxes, customersList, selectedCreditNote, loading } =
//     useSelector(selector);

//   useEffect(() => {
//     dispatch(fetchTaxList({ isPagination: 0 }));
//     if (creditNoteId) {
//       dispatch(fetchCreditNoteById(creditNoteId));
//     }
//   }, [dispatch, creditNoteId]);

//   const taxOptions = (taxList) =>
//     (taxList || []).map((t) => ({
//       label: `${t.name?.toUpperCase()} (${t.taxType})`,
//       value: t.id,
//     }));

//   // Same reverse calculation as the generate form
//   const calculateTotals = (amountInclGst = 0, selectedTaxId = "") => {
//     const grandTotal = Number(amountInclGst) || 0;
//     const selectedTax = taxes.find((t) => t.id === selectedTaxId);

//     let cgstRate = 0,
//       sgstRate = 0;

//     if (selectedTax?.taxType === "C&SGST") {
//       cgstRate = Number(selectedTax.cgst || 0);
//       sgstRate = Number(selectedTax.sgst || 0);
//     }
//     // IGST intentionally ignored for now

//     const totalRate = cgstRate + sgstRate;
//     const taxableAmount =
//       totalRate > 0 ? grandTotal / (1 + totalRate / 100) : grandTotal;

//     const cgst = (taxableAmount * cgstRate) / 100;
//     const sgst = (taxableAmount * sgstRate) / 100;
//     const totalGst = cgst + sgst;

//     const result = {
//       taxableAmount,
//       cgst,
//       sgst,
//       igst: 0,
//       totalGst,
//       grandTotal,
//     };

//     setTotals(result);
//     return result;
//   };

//   const formatDateForApi = (d) => {
//     if (!d) return "";
//     const dt = new Date(d);
//     const y = dt.getFullYear();
//     const m = String(dt.getMonth() + 1).padStart(2, "0");
//     const day = String(dt.getDate()).padStart(2, "0");
//     return `${day}-${m}-${y}`; // dd-mm-yyyy
//   };

//   // Loading state while fetching the existing credit note
//   if (loading || !selectedCreditNote) {
//     return (
//       <div className="p-3">
//         <Row className="g-4">
//           {[...Array(6)].map((_, i) => (
//             <Col md={3} key={i}>
//               <Skeleton height={38} />
//             </Col>
//           ))}
//         </Row>
//       </div>
//     );
//   }

//   const customerName =
//     customersList.find((c) => c.id === selectedCreditNote.customerId)?.name ||
//     selectedCreditNote.customerName;

//   const parseApiDate = (dateStr) => {
//     if (!dateStr) return new Date();

//     if (typeof dateStr === "string" && dateStr.includes("-")) {
//       const parts = dateStr.split("-");
//       if (parts.length === 3) {
//         if (parts[0].length === 4) {
//           const [y, m, d] = parts.map(Number);
//           const parsed = new Date(y, m - 1, d);
//           return isNaN(parsed) ? new Date() : parsed;
//         } else {
//           const [d, m, y] = parts.map(Number);
//           const parsed = new Date(y, m - 1, d);
//           return isNaN(parsed) ? new Date() : parsed;
//         }
//       }
//     }

//     const fallback = new Date(dateStr);
//     return isNaN(fallback) ? new Date() : fallback;
//   };

//   return (
//     <div className="p-3">
//       <Formik
//         enableReinitialize
//         initialValues={{
//           sessionId: selectedCreditNote.sessionId || "",
//           sessionName: selectedCreditNote.sessionName || "",
//           customerId: selectedCreditNote.customerId || "",
//           generateBillId: selectedCreditNote.generateBillId || "",
//           invoiceNo: selectedCreditNote.invoiceNo || "",
//           taxId: selectedCreditNote.taxId || "",
//           creditNoteDate: parseApiDate(selectedCreditNote.creditNoteDate),
//           invoiceAmount: selectedCreditNote.invoiceAmount || 0,
//           amountInclGst: selectedCreditNote.grandTotal || "",
//           note: selectedCreditNote.note || "",
//           tollCharges: selectedCreditNote.tollCharges || 0,
//           otherCharges: selectedCreditNote.otherCharges || 0,
//           handlingCharges: selectedCreditNote.handlingCharges || 0,
//         }}
//         validationSchema={validationSchema}
//         onSubmit={(values) => {
//           const payload = {
//             sessionId: values.sessionId,
//             taxId: values.taxId,
//             taxPerc: taxes.find((t) => t.id === values.taxId)?.taxPerc || 0,
//             creditNoteDate: formatDateForApi(values.creditNoteDate),
//             customerId: values.customerId, // unchanged, sent as-is
//             generateBillId: values.generateBillId, // unchanged, sent as-is
//             invoiceAmount: Number(values.invoiceAmount || 0),
//             creditNoteAmount: Number(totals.taxableAmount.toFixed(2)),
//             cgst: Number(totals.cgst.toFixed(2)),
//             sgst: Number(totals.sgst.toFixed(2)),
//             igst: Number(totals.igst || 0),
//             totalGst: Number(totals.totalGst.toFixed(2)),
//             grandTotal: Number(totals.grandTotal.toFixed(2)),
//             note: values.note || "",
//           };

//           if (onSubmit) onSubmit(selectedCreditNote.id, payload);
//           onCloseForm();
//         }}
//       >
//         {({ values, setFieldValue }) => {
//           useEffect(() => {
//             calculateTotals(values.amountInclGst, values.taxId);
//           }, [taxes.length]);

//           return (
//             <Form>
//               <Row className="g-4">
//                 <Col md={3}>
//                   <div>
//                     <label className="form-label">Session</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={values.sessionName}
//                       disabled
//                     />
//                   </div>
//                 </Col>

//                 {/* Customer — LOCKED */}
//                 <Col md={3}>
//                   <Label>Customer</Label>
//                   <Input type="text" value={customerName || "-"} disabled />
//                 </Col>

//                 {/* Invoice / Bill — LOCKED */}
//                 <Col md={3}>
//                   <Label>Invoice / Bill</Label>
//                   <Input
//                     type="text"
//                     value={values.invoiceNo || values.generateBillId}
//                     disabled
//                   />
//                 </Col>

//                 {/* Invoice Amount (read-only reference) */}
//                 <Col md={3}>
//                   <Label>Invoice Amount</Label>
//                   <Input
//                     type="text"
//                     value={`₹ ${Number(values.invoiceAmount || 0).toFixed(2)}`}
//                     disabled
//                   />
//                 </Col>

//                 {/* Credit Note Date — editable */}
//                 <Col md={3}>
//                   <Label>
//                     Credit Note Date <span className="text-danger">*</span>
//                   </Label>
//                   {/* <Flatpickr
//                     className="form-control"
//                     placeholder="dd-mm-yyyy"
//                     value={values?.creditNoteDate}
//                     options={{
//                       dateFormat: "d-m-Y",
//                       allowInput: true,
//                     }}
//                     onChange={(selectedDates, dateStr) => {
//                       if (selectedDates.length > 0) {
//                         setFieldValue("creditNoteDate", selectedDates[0]);
//                       } else {
//                         setFieldValue("creditNoteDate", dateStr);
//                       }
//                     }}
//                   /> */}

//                   <Flatpickr
//                     className="form-control"
//                     placeholder="dd-mm-yyyy"
//                     value={values?.creditNoteDate}
//                     options={{
//                       dateFormat: "d-m-Y",
//                       allowInput: true,
//                     }}
//                     onChange={(selectedDates) => {
//                       if (selectedDates.length > 0) {
//                         setFieldValue("creditNoteDate", selectedDates[0]);
//                       }
//                     }}
//                     onClose={(selectedDates) => {
//                       if (selectedDates.length > 0) {
//                         setFieldValue("creditNoteDate", selectedDates[0]);
//                       } else {
//                         setFieldValue("creditNoteDate", null); // or leave as-is / show validation error
//                       }
//                     }}
//                   />
//                   <ErrorMessage
//                     name="creditNoteDate"
//                     component="div"
//                     className="text-danger small"
//                   />
//                 </Col>

//                 {/* Tax — editable */}
//                 <Col md={3}>
//                   <Label>
//                     Tax <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     options={taxOptions(taxes)}
//                     value={
//                       values.taxId
//                         ? {
//                             value: values.taxId,
//                             label:
//                               taxes.find((t) => t.id === values.taxId)?.name +
//                               ` (${
//                                 taxes.find((t) => t.id === values.taxId)
//                                   ?.taxType
//                               })`,
//                           }
//                         : null
//                     }
//                     onChange={(opt) => {
//                       const newTaxId = opt?.value || "";
//                       setFieldValue("taxId", newTaxId);
//                       calculateTotals(values.amountInclGst, newTaxId);
//                     }}
//                     placeholder="Select Tax"
//                   />
//                   <ErrorMessage
//                     name="taxId"
//                     component="div"
//                     className="text-danger small"
//                   />
//                 </Col>

//                 {/* Amount inclusive of GST — editable, drives recalculation */}
//                 <Col md={3}>
//                   <Label>
//                     Amount (Incl. GST) <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     value={values.amountInclGst}
//                     onChange={(e) => {
//                       const val = e.target.value;
//                       setFieldValue("amountInclGst", val);
//                       calculateTotals(val, values.taxId);
//                     }}
//                     placeholder="Enter amount including GST"
//                   />
//                   <ErrorMessage
//                     name="amountInclGst"
//                     component="div"
//                     className="text-danger small"
//                   />
//                 </Col>

//                 {/* Note — editable */}
//                 <Col md={3}>
//                   <Label>Note</Label>
//                   <Input
//                     type="text"
//                     value={values.note}
//                     onChange={(e) => setFieldValue("note", e.target.value)}
//                     placeholder="Enter note"
//                   />
//                 </Col>

//                 {/* SUMMARY */}
//                 <Col md={12} className="mt-3">
//                   <h5 className="mb-2">Credit Note Summary</h5>

//                   <Table bordered>
//                     <thead>
//                       <tr>
//                         <th>Taxable Amount</th>

//                         {values.invoiceAmount ? (
//                           <>
//                             <th>Toll Charges</th>
//                             <th>Other Charges</th>
//                             <th>Handling Charges</th>
//                           </>
//                         ) : null}

//                         {(() => {
//                           const selectedTax = taxes.find(
//                             (t) => t.id === values.taxId,
//                           );
//                           if (selectedTax?.taxType === "C&SGST") {
//                             return (
//                               <>
//                                 <th>CGST ({selectedTax.cgst}%)</th>
//                                 <th>SGST ({selectedTax.sgst}%)</th>
//                               </>
//                             );
//                           }
//                           return null;
//                         })()}

//                         <th>Total GST</th>
//                         <th>Grand Total</th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       <tr>
//                         <td>
//                           ₹ {Number(totals.taxableAmount || 0).toFixed(2)}
//                         </td>
//                         {values.invoiceAmount ? (
//                           <>
//                             <td>
//                               ₹ {Number(values.tollCharges || 0).toFixed(2)}
//                             </td>
//                             <td>
//                               ₹ {Number(values.otherCharges || 0).toFixed(2)}
//                             </td>
//                             <td>
//                               ₹ {Number(values.handlingCharges || 0).toFixed(2)}
//                             </td>
//                           </>
//                         ) : null}

//                         {(() => {
//                           const selectedTax = taxes.find(
//                             (t) => t.id === values.taxId,
//                           );
//                           if (selectedTax?.taxType === "C&SGST") {
//                             return (
//                               <>
//                                 <td>₹ {Number(totals.cgst || 0).toFixed(2)}</td>
//                                 <td>₹ {Number(totals.sgst || 0).toFixed(2)}</td>
//                               </>
//                             );
//                           }
//                           return null;
//                         })()}

//                         <td>
//                           <b>₹ {Number(totals.totalGst || 0).toFixed(2)}</b>
//                         </td>
//                         <td>
//                           <b>₹ {Number(totals.grandTotal || 0).toFixed(2)}</b>
//                         </td>
//                       </tr>
//                     </tbody>
//                   </Table>
//                 </Col>

//                 {/* SUBMIT */}
//                 <Col md={12} className="text-end">
//                   <Button color="success" className="btn-sm" type="submit">
//                     Update Credit Note
//                   </Button>
//                 </Col>
//               </Row>
//             </Form>
//           );
//         }}
//       </Formik>
//     </div>
//   );
// };

// export default EditCreditNoteForm;

import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, Button, Table } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";

import { fetchTaxList } from "../../../slices/TaxMaster/thunk";
import { fetchCreditNoteById } from "../../../slices/CreditNote/thunk";

const validationSchema = Yup.object({
  taxId: Yup.string().required("Tax is required"),
  creditNoteDate: Yup.date().required("Credit note date is required"),
  amountInclGst: Yup.number()
    .typeError("Amount must be a number")
    .required("Amount is required")
    .moreThan(0, "Amount must be greater than 0"),
});

const EditCreditNoteForm = ({ creditNoteId, onSubmit, onCloseForm }) => {
  const dispatch = useDispatch();

  const [totals, setTotals] = useState({
    taxableAmount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    totalGst: 0,
    grandTotal: 0,
  });

  const selector = createSelector(
    (state) => state,
    (state) => ({
      taxes: state.TaxMaster.taxes,
      customersList: state.Customer.customers,
      selectedCreditNote: state.CreditNote.selectedCreditNote,
      loading: state.CreditNote.loading,
    }),
  );

  const { taxes, customersList, selectedCreditNote, loading } =
    useSelector(selector);

  useEffect(() => {
    dispatch(fetchTaxList({ isPagination: 0 }));
    if (creditNoteId) {
      dispatch(fetchCreditNoteById(creditNoteId));
    }
  }, [dispatch, creditNoteId]);

  const taxOptions = (taxList) =>
    (taxList || []).map((t) => ({
      label: `${t.name?.toUpperCase()} (${t.taxType})`,
      value: t.id,
    }));

  const roundDown = (value) =>
    Math.floor((Number(value) + Number.EPSILON) * 100) / 100;
  // Same reverse calculation as the generate form:
  // User enters amount INCLUSIVE of GST -> first strip out the extra
  // charges (toll/other/handling), then back out taxable amount, cgst,
  // sgst from what's left. Charges are added back on top at the end so
  // the Grand Total = taxable amount + GST + charges.
  const calculateTotals = (
    amountInclGst = 0,
    selectedTaxId = "",
    extraCharges = 0,
  ) => {
    const enteredAmount = Number(amountInclGst) || 0;
    const charges = Number(extraCharges) || 0;

    // amount left to reverse-calculate GST on, after removing charges
    const amountAfterCharges = enteredAmount - charges;

    const selectedTax = taxes.find((t) => t.id === selectedTaxId);

    let cgstRate = 0,
      sgstRate = 0;

    if (selectedTax?.taxType === "C&SGST") {
      cgstRate = Number(selectedTax.cgst || 0);
      sgstRate = Number(selectedTax.sgst || 0);
    }
    // IGST intentionally ignored for now

    const totalRate = cgstRate + sgstRate;
    const taxableAmount =
      totalRate > 0
        ? amountAfterCharges / (1 + totalRate / 100)
        : amountAfterCharges;

    const cgst = (taxableAmount * cgstRate) / 100;
    const sgst = (taxableAmount * sgstRate) / 100;
    const totalGst = cgst + sgst;

    // Grand Total = taxable amount + GST + charges added back
    const grandTotal = taxableAmount + totalGst + charges;

    const result = {
      taxableAmount,
      cgst,
      sgst,
      igst: 0,
      totalGst,
      charges,
      grandTotal,
    };

    setTotals(result);
    return result;
  };

  // helper — sum of the three charges pulled from the credit note
  const getExtraCharges = (values) =>
    (Number(values.tollCharges) || 0) +
    (Number(values.otherCharges) || 0) +
    (Number(values.handlingCharges) || 0);

  const formatDateForApi = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${day}-${m}-${y}`; // dd-mm-yyyy
  };

  // Loading state while fetching the existing credit note
  if (loading || !selectedCreditNote) {
    return (
      <div className="p-3">
        <Row className="g-4">
          {[...Array(6)].map((_, i) => (
            <Col md={3} key={i}>
              <Skeleton height={38} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  const customerName =
    customersList.find((c) => c.id === selectedCreditNote.customerId)?.name ||
    selectedCreditNote.customerName;

  const parseApiDate = (dateStr) => {
    if (!dateStr) return new Date();

    if (typeof dateStr === "string" && dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          const [y, m, d] = parts.map(Number);
          const parsed = new Date(y, m - 1, d);
          return isNaN(parsed) ? new Date() : parsed;
        } else {
          const [d, m, y] = parts.map(Number);
          const parsed = new Date(y, m - 1, d);
          return isNaN(parsed) ? new Date() : parsed;
        }
      }
    }

    const fallback = new Date(dateStr);
    return isNaN(fallback) ? new Date() : fallback;
  };

  return (
    <div className="p-3">
      <Formik
        enableReinitialize
        initialValues={{
          sessionId: selectedCreditNote.sessionId || "",
          sessionName: selectedCreditNote.sessionName || "",
          customerId: selectedCreditNote.customerId || "",
          generateBillId: selectedCreditNote.generateBillId || "",
          invoiceNo: selectedCreditNote.invoiceNo || "",
          taxId: selectedCreditNote.taxId || "",
          creditNoteDate: parseApiDate(selectedCreditNote.creditNoteDate),
          invoiceAmount: selectedCreditNote.invoiceAmount || 0,
          amountInclGst: selectedCreditNote.grandTotal || "",
          note: selectedCreditNote.note || "",
          tollCharges: selectedCreditNote.tollCharges || 0,
          otherCharges: selectedCreditNote.otherCharges || 0,
          handlingCharges: selectedCreditNote.handlingCharges || 0,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const payload = {
            sessionId: values.sessionId,
            taxId: values.taxId,
            taxPerc: taxes.find((t) => t.id === values.taxId)?.taxPerc || 0,
            creditNoteDate: formatDateForApi(values.creditNoteDate),
            customerId: values.customerId, // unchanged, sent as-is
            generateBillId: values.generateBillId, // unchanged, sent as-is
            invoiceAmount: Number(values.invoiceAmount || 0),
            creditNoteAmount: Number(totals.taxableAmount.toFixed(2)),
            cgst: Number(totals.cgst.toFixed(2)),
            sgst: Number(totals.sgst.toFixed(2)),
            igst: Number(totals.igst || 0),
            totalGst: Number(totals.totalGst.toFixed(2)),
            grandTotal: Number(totals.grandTotal.toFixed(2)), // taxable + GST + charges
            note: values.note || "",
          };

          if (onSubmit) onSubmit(selectedCreditNote.id, payload);
          onCloseForm();
        }}
      >
        {({ values, setFieldValue }) => {
          useEffect(() => {
            calculateTotals(
              values.amountInclGst,
              values.taxId,
              getExtraCharges(values),
            );
          }, [taxes.length]);

          return (
            <Form>
              <Row className="g-4">
                <Col md={3}>
                  <div>
                    <label className="form-label">Session</label>
                    <input
                      type="text"
                      className="form-control"
                      value={values.sessionName}
                      disabled
                    />
                  </div>
                </Col>

                {/* Customer — LOCKED */}
                <Col md={3}>
                  <Label>Customer</Label>
                  <Input type="text" value={customerName || "-"} disabled />
                </Col>

                {/* Invoice / Bill — LOCKED */}
                <Col md={3}>
                  <Label>Invoice / Bill</Label>
                  <Input
                    type="text"
                    value={values.invoiceNo || values.generateBillId}
                    disabled
                  />
                </Col>

                {/* Invoice Amount (read-only reference) */}
                <Col md={3}>
                  <Label>Invoice Amount</Label>
                  <Input
                    type="text"
                    value={`₹ ${Number(values.invoiceAmount || 0).toFixed(2)}`}
                    disabled
                  />
                </Col>

                {/* Credit Note Date — editable */}
                <Col md={3}>
                  <Label>
                    Credit Note Date <span className="text-danger">*</span>
                  </Label>
                  {/* <Flatpickr
                    className="form-control"
                    placeholder="dd-mm-yyyy"
                    value={values?.creditNoteDate}
                    options={{
                      dateFormat: "d-m-Y",
                      allowInput: true,
                    }}
                    onChange={(selectedDates, dateStr) => {
                      if (selectedDates.length > 0) {
                        setFieldValue("creditNoteDate", selectedDates[0]);
                      } else {
                        setFieldValue("creditNoteDate", dateStr);
                      }
                    }}
                  /> */}

                  <Flatpickr
                    className="form-control"
                    placeholder="dd-mm-yyyy"
                    value={values?.creditNoteDate}
                    options={{
                      dateFormat: "d-m-Y",
                      allowInput: true,
                    }}
                    onChange={(selectedDates) => {
                      if (selectedDates.length > 0) {
                        setFieldValue("creditNoteDate", selectedDates[0]);
                      }
                    }}
                    onClose={(selectedDates) => {
                      if (selectedDates.length > 0) {
                        setFieldValue("creditNoteDate", selectedDates[0]);
                      } else {
                        setFieldValue("creditNoteDate", null); // or leave as-is / show validation error
                      }
                    }}
                  />
                  <ErrorMessage
                    name="creditNoteDate"
                    component="div"
                    className="text-danger small"
                  />
                </Col>

                {/* Tax — editable */}
                <Col md={3}>
                  <Label>
                    Tax <span className="text-danger">*</span>
                  </Label>
                  <Select
                    options={taxOptions(taxes)}
                    value={
                      values.taxId
                        ? {
                            value: values.taxId,
                            label:
                              taxes.find((t) => t.id === values.taxId)?.name +
                              ` (${
                                taxes.find((t) => t.id === values.taxId)
                                  ?.taxType
                              })`,
                          }
                        : null
                    }
                    onChange={(opt) => {
                      const newTaxId = opt?.value || "";
                      setFieldValue("taxId", newTaxId);
                      calculateTotals(
                        values.amountInclGst,
                        newTaxId,
                        getExtraCharges(values),
                      );
                    }}
                    placeholder="Select Tax"
                  />
                  <ErrorMessage
                    name="taxId"
                    component="div"
                    className="text-danger small"
                  />
                </Col>

                {/* Amount inclusive of GST — editable, drives recalculation */}
                <Col md={3}>
                  <Label>
                    Amount (Incl. GST) <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="number"
                    min="0"
                    step="0.01"
                    value={values.amountInclGst}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFieldValue("amountInclGst", val);
                      calculateTotals(
                        val,
                        values.taxId,
                        getExtraCharges(values),
                      );
                    }}
                    placeholder="Enter amount including GST"
                  />
                  <ErrorMessage
                    name="amountInclGst"
                    component="div"
                    className="text-danger small"
                  />
                </Col>

                {/* Note — editable */}
                <Col md={3}>
                  <Label>Note</Label>
                  <Input
                    type="text"
                    value={values.note}
                    onChange={(e) => setFieldValue("note", e.target.value)}
                    placeholder="Enter note"
                  />
                </Col>

                {/* SUMMARY */}
                <Col md={12} className="mt-3">
                  <h5 className="mb-2">Credit Note Summary</h5>

                  <Table bordered>
                    <thead>
                      <tr>
                        <th>Taxable Amount</th>

                        {values.invoiceAmount ? (
                          <>
                            <th>Toll Charges</th>
                            <th>Other Charges</th>
                            <th>Handling Charges</th>
                          </>
                        ) : null}

                        {(() => {
                          const selectedTax = taxes.find(
                            (t) => t.id === values.taxId,
                          );
                          if (selectedTax?.taxType === "C&SGST") {
                            return (
                              <>
                                <th>CGST ({selectedTax.cgst}%)</th>
                                <th>SGST ({selectedTax.sgst}%)</th>
                              </>
                            );
                          }
                          return null;
                        })()}

                        <th>Total GST</th>
                        <th>Grand Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          ₹ {Number(totals.taxableAmount || 0).toFixed(2)}
                        </td>
                        {values.invoiceAmount ? (
                          <>
                            <td>
                              ₹ {Number(values.tollCharges || 0).toFixed(2)}
                            </td>
                            <td>
                              ₹ {Number(values.otherCharges || 0).toFixed(2)}
                            </td>
                            <td>
                              ₹ {Number(values.handlingCharges || 0).toFixed(2)}
                            </td>
                          </>
                        ) : null}

                        {(() => {
                          const selectedTax = taxes.find(
                            (t) => t.id === values.taxId,
                          );
                          if (selectedTax?.taxType === "C&SGST") {
                            return (
                              <>
                                <td>₹ {Number(totals.cgst || 0).toFixed(2)}</td>
                                <td>₹ {Number(totals.sgst || 0).toFixed(2)}</td>
                              </>
                            );
                          }
                          return null;
                        })()}

                        <td>
                          <b>₹ {Number(totals.totalGst || 0).toFixed(2)}</b>
                        </td>
                        <td>
                          <b>₹ {Number(totals.grandTotal || 0).toFixed(2)}</b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>

                {/* SUBMIT */}
                <Col md={12} className="text-end">
                  <Button color="success" className="btn-sm" type="submit">
                    Update Credit Note
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditCreditNoteForm;
